import styled from '@emotion/styled';
import { sizes } from '@smartsheet/lodestar-core';
import { shadows } from '@smartsheet/lodestar-core/dist/esm/constants/layers';
import { motion, Variants } from 'framer-motion';
import React from 'react';
import { PANEL_SPACE_BOTTOM } from '../../../../utils/dimensions';
import { transitionData } from './utils/animation';
import * as colors from './utils/colors';

const StyledRightPanelContainerAnimation = styled(motion.div)<{
  width: string;
}>`
  position: absolute; // for animations
  top: 0;
  bottom: ${PANEL_SPACE_BOTTOM}px;
  height: calc(100vh - 80px);
  width: ${({ width }) => width};
  background-color: ${colors.panelBg};
  box-shadow: ${shadows.modal};
  z-index: 4; // behind the rail
`;

interface RightPanelContainerProps {
  isOpen: boolean;
  clientId?: string;
  width: string;
  panelId?: string;
}

const rightPanelContainerVariants: Variants = {
  rest: {
    right: 20,
    opacity: 0,

    // don't want the user to accidentally "grab" the panel as it's closing
    pointerEvents: 'none',

    transitionEnd: {
      display: 'none',
    },
  },
  open: {
    right: sizes.xSmall + 48,
    opacity: 1,
    pointerEvents: 'auto',
    display: 'block',
  },
};

export const RightPanelContainer: React.FC<RightPanelContainerProps> = ({
  isOpen,
  clientId,
  width,
  children,
  panelId,
}) => {
  const intendedState = isOpen ? 'open' : 'rest';

  return (
    <StyledRightPanelContainerAnimation
      width={width}
      animate={intendedState}
      variants={rightPanelContainerVariants}
      transition={transitionData}
      initial={false}
      data-client-id={clientId}
      id={panelId}
    >
      {children}
    </StyledRightPanelContainerAnimation>
  );
};
